import { createQueryKeys } from '@lukemorales/query-key-factory'

export const queries = createQueryKeys('storage', {
  image: (path: string) => ['image', { path }],
  localImagesByMomentId: (momentId: string) => [
    'local-images-by-moment-id',
    { momentId },
  ],
})
